import { createSelector } from 'reselect';

export const getScripts = state => state.scripts;

export const getScript = createSelector(getScripts, scripts => scriptName => {
  const script = scripts.find(event => event.name === scriptName);
  if (script && script.value) {
    return script.value || null;
  }
  return null;
});



// WEBPACK FOOTER //
// ./src/store/reducers/scripts/selectors.js